import { createSelector } from '@reduxjs/toolkit';

const selectHeader = state => state.header;

export const selectDownloading = createSelector(selectHeader, header => {
  const { downloading_video, downloading_percent } = header;

  return {
    isDownloading: downloading_video,
    percent: downloading_percent,
  };
});
